<template>
  <v-layout class="fontlao">
    <v-navigation-drawer v-model="drawer" temporary>
      <v-list-item :prepend-avatar="require('../../../src/assets/logo.png')" :title="title"
        :subtitle="subtitle"></v-list-item>

      <v-divider></v-divider>

      <v-list density="compact" nav>
        <v-list-group v-for="(item, index) in drawerItems" :key="index" :value="item.route" :prepend-icon="item.icon"
          :append-icon="item.menus == null ? 'mdi-chevron-right' : ''">
          <template v-slot:activator="{ props }">
            <v-list-item v-if="item.menus" v-bind="props" :title="item.menu_name" />
            <v-list-item v-else v-bind="props" :title="item.menu_name" :to="item.route"  @click="item.use_action == null ? '':menuActionClick(item.use_action)"/>
          </template>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-app-bar absolute :height="100" color="primary" :elevation="0">
        <template v-slot:prepend>
          <v-app-bar-nav-icon v-if="!hideMenu" @click.stop="drawer = !drawer" color="white"></v-app-bar-nav-icon>
          <v-img v-else v-show="hideImg" :height="80" :min-height="60" :min-width="110"
            :src="require('../../../src/assets/logo.png')" />
        </template>

        <v-row>
          <v-col>
            <v-row class="ml-4">
              <h2>{{ title }}</h2>
            </v-row>
            <v-row v-if="hideMenu" class="ml-4 mt-2">
              <h3>{{ subtitle }}</h3>
            </v-row>
          </v-col>
        </v-row>

        <v-spacer />

        <div v-if="hideMenu" class="ml-8 mr-10">
          <v-row>
            <v-menu v-for="(item, index) in menuItems" :key="index" offset-y>

              <template v-if="item.hasNoti" v-slot:activator="{ props }">
                <v-badge  color="error" :content="item.counter">
                  <v-btn v-if="item.menus != null" text v-bind="props">
                    <!-- <v-icon class="ma-1" left :icon="item.icon" /> -->

                    {{ item.menu_name }}
                  </v-btn>

                  <v-btn class="f-color mx-1" v-if="item.menus == null" :to="item.route" >
                    <!-- <v-icon class="ma-1" left :icon="item.icon" /> -->
                    {{ item.menu_name }}
                  </v-btn>
                </v-badge>
              </template>

              <template v-else v-slot:activator="{ props }">
                <v-btn v-if="item.menus != null" text v-bind="props">
                  <!-- <v-icon class="ma-1" left :icon="item.icon" /> -->
                  {{ item.menu_name }}
                </v-btn>
                <v-btn v-else class="f-color mx-1" v-if="item.menus == null" :to="item.route" >
                  <!-- <v-icon class="ma-1" left :icon="item.icon" /> -->
                  {{ item.menu_name }}
                </v-btn>
              </template>

              <v-list v-if="item.menus">
                <v-list-item class="fontlao" v-for="(menu, i) in item.menus" :key="i" :to="item.route + menu.route">
                  <template v-if="menu.hasNoti" v-slot:title>
                    <v-badge :content="menu.counter">
                      <span>
                        {{ menu.menu_name }}
                      </span>
                    </v-badge>

                  </template>
                  <template v-else v-slot:title>
                    <span>
                      {{ menu.menu_name }}
                    </span>
                  </template>
                </v-list-item>
              </v-list>
            </v-menu>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="button" icon="pi pi-user" severity="info" rounded aria-label="User" @click="toggle" aria-haspopup="true" aria-controls="overlay_menu" />
            <Menu ref="menu" id="overlay_menu" :model="user_menu_items" :popup="true" />
          </v-row>
        </div>

        

      </v-app-bar>

      <router-view class="pb-16 px-3" />

      <LoadingOverlay v-if="loading" />
      <SnackbarSuccess v-if="alertSucces" />
      <SnackbarFailed v-if="alertFail" />
      <v-footer class="bg-primary footer">
        <div class="px-4 py-2 bg-primary text-center w-100">
          <strong>
            Copyright © {{ new Date().getFullYear() }} DDT, Ministry of
            Technology and Communication. Powered by SITC Lao.
          </strong>
        </div>
      </v-footer>
    </v-main>
  </v-layout>
</template>

<script>
import { useDisplay } from "vuetify";
import { computed, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import LoadingOverlay from "../alert/loading-overlay.vue";
import SnackbarFailed from "../alert/Snackbar-Failed.vue";
import SnackbarSuccess from "../alert/Snackbar-Success.vue";
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import { useRouter } from "vue-router";
export default {
  components: {
    LoadingOverlay,
    SnackbarSuccess,
    SnackbarFailed,
    Button,
    Menu,
  },
  data: () => ({
    title: "ກົມເຕັກໂນໂລຊີດີຈີຕອນ",
    subtitle: "Department of Digital Technology",
    username: "SITC Lao",
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
  }),
  setup() {
    const store = useStore();
    const router = useRouter();
    const drawer = ref(null);
    const hideMenu = ref(true);
    const hideImg = ref(true);
    const { width } = useDisplay();
    const menuItems = computed(() => store.state["entPageModule"].nav_menu);
    const drawerItems = computed(() => store.state["entPageModule"].drawer_menu);
    const menu = ref();
    const user_menu_items = ref([
        {
            label: 'Options',
            items: [
                {
                    label: 'ປ່ຽນລະຫັດຜ່ານ',
                    icon: 'pi pi-key',
                    command: () => {
                      router.push({ path: "/change-password" });
                    },
                },
                {
                    label: 'ອອກຈາກລະບົບ',
                    icon: 'pi pi-sign-out',
                    command: () => {
                      logout();
                    },
                }
            ]
        }
    ]);
    const toggle = (event) => {
        menu.value.toggle(event);
    };

    watch(width, (width) => {
      responsive(width);
    });

    onMounted(() => {
      store.dispatch("authPageModule/getUserMain");
      responsive(width.value);
    });

    const responsive = (width) => {
      if (width < 940) {
        hideMenu.value = false;
      } else {
        hideMenu.value = true;
      }

      if (width < 1200) {
        hideImg.value = false;
      } else {
        hideImg.value = true;
      }
    };

    const menuActionClick = (action) => {
      if(action == "logout"){
        logout();
      }
    };

    const logout = () => {
      store.dispatch("authPageModule/logout");
    };

    return {
      store,
      router,
      logout,
      drawer,
      hideMenu,
      hideImg,
      menuItems,
      drawerItems,
      user_menu_items,
      menu,
      toggle,
      menuActionClick,
    };
  },
  computed: {
    alertSucces: {
      get() {
        return this.$store.state.snackbarSuccess;
      },
    },
    alertFail: {
      get() {
        return this.$store.state.snackbarFailed;
      },
    },
    loading: {
      get() {
        return this.$store.state.LoadingOverlay;
      },
    },
  },
};
</script>

<style>
.fontlao {
  font-family: phetsarath ot !important;
}
.p-menu-item-label{
  font-family: phetsarath ot !important;
}
.f-color {
  color: white;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  /* Height of the footer */
  background: #6cf;
}
</style>
